/* Goldenage locked page. Loaded with defer from sections/goldenage-locked.liquid (the password
   layout loads no theme JS of its own). Five independent pieces: the view ping, countdown,
   password modal, two-step Klaviyo signup, the questions sheet. One ticker that reads the DOM
   every second, so the theme editor morphing the section does not leave a dead clock behind. */

/* ---------- view ping: one POST /view per browser session ----------
   Shopify does not count views of the password page (it is outside the online store, so its
   sessions metric never sees it), and a signup count with no view count is not a rate. So the
   page tells the same Worker that takes the signups that it was seen, once per browser session:
   the id lives in sessionStorage, so a reload or a second visit in the same tab sends nothing and
   a new tab or a new browser sends one. Nothing personal is sent, only the id. Fire and forget,
   after first paint, never on localhost (the offline harness), and a browser with storage blocked
   still pings with no id, which the Worker counts under a one-off id rather than losing it. */
(function () {
  var root = document.querySelector('[data-gal][data-view-proxy]');
  if (!root) return;
  var endpoint = root.getAttribute('data-view-proxy') || '';
  if (!/^https?:\/\//.test(endpoint)) return;
  if (/^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname)) return;
  var view = endpoint.replace(/\/[^/]*\/?$/, '') + '/view';
  var KEY = 'gal_lock_sid';
  var sid = '', fresh = false;
  try { sid = sessionStorage.getItem(KEY) || ''; } catch (e) {}
  if (!sid) {
    fresh = true;
    sid = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try { sessionStorage.setItem(KEY, sid); } catch (e) { sid = ''; }
  }
  if (!fresh && sid) return;
  function ping() {
    try {
      fetch(view, { method: 'POST', keepalive: true, mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sid: sid }) }).catch(function () {});
    } catch (e) {}
  }
  if ('requestIdleCallback' in window) requestIdleCallback(ping, { timeout: 2000 });
  else setTimeout(ping, 600);
})();

(function () {
  /* ---------- countdown ---------- */
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  function tick() {
    var cd = document.querySelector('[data-gal-cd]');
    if (!cd) return;
    var deadline = new Date(cd.getAttribute('data-deadline')).getTime();
    if (isNaN(deadline)) return;
    var grid = cd.querySelector('[data-gal-grid]');
    var live = cd.querySelector('[data-gal-live]');
    var now = Date.now();
    var diff = deadline - now;

    /* The door band under the clock. data-early is the early access door (17:45 PT); it never
       touches the clock, which counts to the public open only. Before the early door: no band.
       Early door open, public not yet: the early text and the password button. Public open and
       the page still locked (password not yet off): the second text. */
    var door = document.querySelector('[data-gal-door]');
    if (door) {
      var early = new Date(cd.getAttribute('data-early') || '').getTime();
      var earlyOpen = !isNaN(early) && now >= early;
      var publicOpen = diff <= 0;
      var eT = door.querySelector('[data-gal-door-early]');
      var oT = door.querySelector('[data-gal-door-open]');
      var showEarly = earlyOpen && !publicOpen && !!eT;
      var showOpen = publicOpen && !!oT;
      if (eT) eT.hidden = !showEarly;
      if (oT) oT.hidden = !showOpen;
      door.hidden = !(showEarly || showOpen);
    }

    if (diff <= 0) {
      if (grid) grid.hidden = true;
      if (live) { live.hidden = false; live.textContent = cd.getAttribute('data-live') || ''; }
      return;
    }
    var s = Math.floor(diff / 1000);
    var set = function (sel, v) { var el = cd.querySelector(sel); if (el && el.textContent !== v) el.textContent = v; };
    set('[data-d]', pad(Math.floor(s / 86400)));
    set('[data-h]', pad(Math.floor((s % 86400) / 3600)));
    set('[data-m]', pad(Math.floor((s % 3600) / 60)));
    set('[data-s]', pad(s % 60));
  }
  tick();
  if (!window.__galTicker) window.__galTicker = setInterval(tick, 1000);

  /* ---------- password modal ---------- */
  var sec = document.querySelector('[data-gal]');
  if (!sec || sec.__gal) return; sec.__gal = true;
  var passWrap = sec.querySelector('[data-gal-pass]');
  function pass(open) {
    sec.classList.toggle('pass-open', open);
    if (open) { var f = sec.querySelector('.gal-pass__form input'); if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 220); }
  }
  sec.querySelectorAll('[data-gal-pass-open]').forEach(function (b) { b.addEventListener('click', function () { closeFaq(); pass(true); }); });
  sec.querySelectorAll('[data-gal-pass-close]').forEach(function (b) { b.addEventListener('click', function () { pass(false); }); });
  if (passWrap && passWrap.querySelector('[data-gal-pass-err]')) pass(true); /* a wrong password reloads the page with the form errored */

  /* ---------- questions sheet (the tab stuck to the bottom) ----------
     The Park Friends mechanic: unhide the overlay and the sheet first, then set data-open in the
     NEXT frame so the browser has painted the sheet below the fold before the transform changes.
     Setting both in the same tick skips the slide. Reading offsetHeight in between flushes the
     style so the rAF cannot land before the sheet's first layout. Close: drop data-open, hide
     once the .34s slide has run. */
  var faq = sec.querySelector('[data-gal-faq]');
  var faqSheet = faq && faq.querySelector('[data-gal-faq-sheet]');
  var faqOvl = faq && faq.querySelector('.gal-faq__ovl');
  var faqBar = faq && faq.querySelector('[data-gal-faq-open]');
  var faqTimer = null;
  function openFaq() {
    if (!faq) return;
    clearTimeout(faqTimer);
    faqOvl.hidden = false; faqSheet.hidden = false;
    void faqSheet.offsetHeight;
    faqBar.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { faq.setAttribute('data-open', ''); });
  }
  function closeFaq() {
    if (!faq || !faq.hasAttribute('data-open')) return;
    faq.removeAttribute('data-open');
    faqBar.setAttribute('aria-expanded', 'false');
    faqTimer = setTimeout(function () { faqOvl.hidden = true; faqSheet.hidden = true; }, 340);
  }
  if (faq) {
    faqBar.addEventListener('click', function () { faq.hasAttribute('data-open') ? closeFaq() : openFaq(); });
    faq.querySelectorAll('[data-gal-faq-close]').forEach(function (b) { b.addEventListener('click', closeFaq); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { pass(false); closeFaq(); } });
})();

/* ---------- Klaviyo, two steps: email, then phone behind the consent tick ---------- */
(function () {
  var box = document.querySelector('[data-gal-signup]');
  if (!box || box.__k) return; box.__k = true;
  var PROXY = box.getAttribute('data-proxy') || '';
  var COMPANY = box.getAttribute('data-company') || '';
  var EMAIL_LIST = box.getAttribute('data-email-list') || '';
  var SMS_LIST = box.getAttribute('data-sms-list') || '';
  var source = box.getAttribute('data-source') || 'Locked page';
  var f1 = box.querySelector('[data-gal-step1]'), f2 = box.querySelector('[data-gal-step2]'), f3 = box.querySelector('[data-gal-step3]');
  var email = '';
  var KEY = 'gal_list', DAYS = 60;

  function remember(state) { try { localStorage.setItem(KEY, JSON.stringify({ s: state, e: email, t: Date.now() })); } catch (e) {} }
  function recall() {
    try {
      var j = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!j || Date.now() - j.t > DAYS * 86400000) return null;
      return j;
    } catch (e) { return null; }
  }
  function err(form, msg) { var e = form.querySelector('[data-gal-err]'); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; }
  function busy(form, on) { var b = form.querySelector('button[type=submit]'); if (b) { b.disabled = on; b.setAttribute('aria-busy', on ? 'true' : 'false'); } }
  function show(step, noFocus) {
    [f1, f2, f3].forEach(function (s) { if (s) s.hidden = s !== step; });
    if (noFocus) return;
    var i = step && step.querySelector('input:not([disabled]):not([type=checkbox])'); if (i) try { i.focus({ preventScroll: true }); } catch (e) {}
  }

  /* The brand's own forwarder first (server side, so an ad blocker on a.klaviyo.com cannot drop
     the signup), then Klaviyo's client API straight from the browser as the fallback. */
  function proxy(payload) {
    if (!PROXY) return Promise.reject(new Error('no proxy'));
    return fetch(PROXY, { method: 'POST', headers: { 'content-type': 'text/plain' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.success) return true; var e = new Error((j && j.errors && j.errors[0]) || 'failed'); e.said = e.message; e.final = true; throw e; });
  }
  function direct(attrs, list) {
    if (!COMPANY) return Promise.reject(new Error('no company'));
    var body = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } } } };
    if (list) body.data.relationships = { list: { data: { type: 'list', id: list } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST', headers: { 'content-type': 'application/json', revision: '2025-01-15' }, body: JSON.stringify(body),
    }).then(function (r) { if (r.status >= 200 && r.status < 300) return true; return r.text().then(function (t) { var e = new Error(t || ('status ' + r.status)); e.status = r.status; throw e; }); });
  }
  function bad(e) { return e && ((e.status === 400 && /email/i.test(e.message || '')) || /email/i.test(e.said || '')); }

  if (f1) f1.addEventListener('submit', function (ev) {
    ev.preventDefault(); err(f1, '');
    var v = (f1.querySelector('input[name=email]').value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err(f1, 'That email does not look right. Check it and try again.'); return; }
    busy(f1, true);
    proxy({ email: v, source: source })
      .catch(function (e) { if (e.final) throw e; return direct({ email: v, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, EMAIL_LIST); })
      .then(function () { email = v; remember('email'); show(f2); })
      .catch(function (e) { err(f1, (e && e.final && e.said) || (bad(e) ? 'That email does not look right. Check it and try again.' : 'That did not go through. Try again in a moment.')); })
      .then(function () { busy(f1, false); });
  });

  if (f2) f2.addEventListener('submit', function (ev) {
    ev.preventDefault(); err(f2, '');
    var agree = f2.querySelector('[data-gal-agree]');
    if (agree && !agree.checked) { err(f2, 'Tick the box first, so we are allowed to text you.'); try { agree.focus(); } catch (x) {} return; }
    var cc = f2.querySelector('select[name=cc]').value, raw = (f2.querySelector('input[name=phone]').value || '').replace(/\D/g, '');
    if (cc === '+1' && raw.length === 11 && raw.charAt(0) === '1') raw = raw.slice(1);
    /* US/CA: 10 digits, area code and exchange cannot start with 0 or 1 (NANP). Klaviyo accepts
       anything and silently drops what is not a real number, so it is checked here first. */
    if (cc === '+1' && !/^[2-9]\d{2}[2-9]\d{6}$/.test(raw)) { err(f2, 'That number does not look right. Check it and try again.'); return; }
    busy(f2, true);
    var phone = cc + raw;
    proxy({ email: email, phone: phone, sms_consent: true, source: source })
      .catch(function (e) { if (e.final) throw e; return direct({ email: email, phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } }, SMS_LIST); })
      .then(function () { remember('sms'); show(f3); })
      .catch(function (e) { err(f2, (e && e.said) || 'We could not save that number. Check it and try again.'); })
      .then(function () { busy(f2, false); });
  });

  /* The tick is what opens the number. Nothing can be typed or sent until it is ticked. */
  var agreeBox = f2 && f2.querySelector('[data-gal-agree]');
  function gate() {
    var on = !agreeBox || agreeBox.checked;
    f2.querySelectorAll('select[name=cc], input[name=phone], button[type=submit]').forEach(function (el) { el.disabled = !on; });
    if (on) { err(f2, ''); var p = f2.querySelector('input[name=phone]'); if (p && agreeBox && agreeBox.checked) try { p.focus({ preventScroll: true }); } catch (e) {} }
  }
  if (agreeBox) { agreeBox.addEventListener('change', gate); gate(); }
  var skip = box.querySelector('[data-gal-skip]');
  if (skip) skip.addEventListener('click', function () { remember('skipped'); show(f3); });

  /* A returning visitor (60 days) sees where they left off instead of the empty form. */
  var past = recall();
  if (past && past.s === 'sms') show(f3, true);
  else if (past && past.s === 'skipped') show(f3, true);
  else if (past && past.s === 'email') { email = past.e || ''; if (email) show(f2, true); }
})();
